import { WAC_TO_CPAPI_LOCALE_MAP } from '@/utils/content-queries/constants';
import { SupportedLocales } from '@/utils/localization';

import { getWacManagementLiveCompositionRequest } from '../../bifrost-template/wac-management-regeneration-request';

type State = 'draft' | 'published';

export const getLiveComposition = async (
	queryParams: URLSearchParams,
	route: string,
	currLocale: SupportedLocales = 'en-US',
	// eslint-disable-next-line complexity
) => {
	const projectId = queryParams.get('projectId');
	const compositionId = queryParams.get('compositionId');
	const compositionState: State = (queryParams.get('compositionState') as State) ?? 'draft';
	const contentfulEnv = queryParams.get('contentfulEnv') ?? 'master';
	const contentfulState: State = (queryParams.get('contentfulState') as State) ?? 'draft';
	const locale = queryParams.get('locale') ?? WAC_TO_CPAPI_LOCALE_MAP[currLocale] ?? 'en-US';
	const pageUrl = route.startsWith('/') ? route : `/${route}`;

	const wacmanParams = new URLSearchParams({
		projectId: projectId ?? '',
		compositionId: compositionId ?? '',
		compositionState,
		contentfulEnv,
		contentfulState,
		locale,
		pageUrl,
		hydrate: 'true',
	});

	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), 12000);

	const { endpoint, requestOptions } = getWacManagementLiveCompositionRequest(
		wacmanParams,
		controller.signal,
	);

	try {
		const response = await fetch(endpoint, requestOptions);
		clearTimeout(timeoutId);
		if (!response.ok) {
			console.warn(`getLiveComposition: wac-management-service responded ${response.status}`);
			return undefined;
		}
		const result = await response.json();
		if (result.error) {
			console.warn('getLiveComposition: error in response:', result.error);
		}
		return result.composition;
	} catch (e) {
		clearTimeout(timeoutId);
		const err = e instanceof Error ? e : new Error(String(e));
		const cause = (err as Error & { cause?: unknown }).cause;
		const causeInfo =
			cause instanceof Error
				? ` cause=${(cause as Error & { code?: string }).code ?? cause.name} causeMessage=${cause.message}`
				: ' cause=none';
		console.warn(`getLiveComposition: fetch failed - ${err.name}: ${err.message}${causeInfo}`);
		return undefined;
	}
};
